import { AxiosError } from "axios";

export const getAxiosErrorMessage = (
  error: unknown,
  fallbackMessage: string,
): string => {
  const errorObj = error as AxiosError<{ message?: string; errors?: unknown }>;

  const errors = errorObj?.response?.data?.errors;
  const backendMessage = errorObj?.response?.data?.message;

  if (typeof errors === "string" && errors.trim().length) return errors;

  if (Array.isArray(errors)) {
    const msgs = errors
      .map((e) => (typeof e === "string" ? e.trim() : ""))
      .filter(Boolean);
    if (msgs.length) return msgs.join("\n");
  }

  if (errors && typeof errors === "object") {
    const values = Object.values(errors as Record<string, unknown>);
    const msgs = values
      .flatMap((v) => {
        if (typeof v === "string") return [v.trim()];
        if (Array.isArray(v)) {
          return v
            .map((x) => (typeof x === "string" ? x.trim() : ""))
            .filter(Boolean);
        }
        return [];
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join("\n");
  }

  if (typeof backendMessage === "string" && backendMessage.trim().length) {
    return backendMessage;
  }

  return fallbackMessage;
};
